module.exports = __webpack_public_path__ + "static/media/space-cover.e80548c9.jpg";